<script setup>
import { nextTick, onMounted, ref, reactive } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import categoryAdjust from "./categoryAdjust.vue";
import manageAdjust from "./manageAdjust.vue";
import {
  queryMedicamentPage,
  queryMedicamentTree,
  deleteMedicamentTree,
  deleteMedicament,
} from "@/api/medicament";
const defaultProps = {
  label: "name",
  // disabled: function (data, node) {
  //   if (data.parentId == "0") {
  //     return true;
  //   }
  // },
};

// 搜索条件
const searchData = reactive({
  name: null,
  nickname: null,
  number: null,
  categoryId: null,
});

// 搜索条件ref
const searchRef = ref(null);

// 物料分类ref
const categoryRef = ref(null);

// 物料管理的ref
const materielRef = ref(null);

// 树结构的ref
const treeRef = ref(null);

// 表格配置
const columns = ref([
  {
    label: "药剂名称",
    prop: "name",
    fixed: true,
  },
  {
    label: "药剂编号",
    prop: "number",
  },
  {
    label: "药剂简称",
    prop: "nickname",
  },
  {
    label: "药剂类别",
    prop: "categoryName",
  },
  {
    label: "药剂单价(元)",
    prop: "price",
  },
  {
    label: "状态",
    prop: "enable",
  },
  {
    label: "创建人",
    prop: "createName",
  },
  {
    label: "创建时间",
    prop: "createTime",
  },
]);

// 表格数据
const tableData = ref([]);

// 表格遮罩
const tableLoading = ref(false);

// 物料类别遮罩
const treeLoading = ref(false);

// 分页参数
const pageParams = reactive({
  page: 1,
  limit: 10,
  total: 0,
});

// 物料类型树
const typeTree = ref([]);

// 获取表格数据
const getList = () => {
  tableLoading.value = true;
  queryMedicamentPage({
    ...searchData,
    page: pageParams.page,
    limit: pageParams.limit,
  })
    .then((res) => {
      tableData.value = res.data.records;
      pageParams.total = res.data.total;
    })
    .finally(() => {
      tableLoading.value = false;
    });
};

// 获取类型树
const getTypeTree = () => {
  treeLoading.value = true;
  queryMedicamentTree({})
    .then((res) => {
      if (JSON.stringify(res.data) != "{}") {
        typeTree.value = res.data || [];
      }
    })
    .finally(() => {
      treeLoading.value = false;
    });
};

// 重置按钮
const handleReset = () => {
  searchRef.value?.resetFields();
  getList();
};

// 树点击新增或编辑
const handleCategoryAdjust = (node, data, type) => {
  categoryRef.value?.handleDialogOpen({
    node,
    data,
    type,
    tree: typeTree.value,
  });
};

// 点击类别删除
const handleCategoryDelete = (data) => {
  if (data.parentId == "0") return ElMessage.error("根节点不可删除");
  ElMessageBox.confirm(`确定删除类别【${data.name}】吗？`, "警告", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "error",
  })
    .then(() => {
      deleteMedicamentTree(data.id).then((res) => {
        if (res.code == "2000") {
          ElMessage.success("操作成功");
          getTypeTree();
        }
      });
    })
    .catch(() => {});
};

// 点击类别
const handleNodeClick = (val) => {
  searchData.categoryId = val.parentId == "0" ? null : val.id;
  getList();
};

// 点击物料管理的新增或编辑
const handleMaterielAdjust = (row, type, tree) => {
  materielRef.value?.handleDialogOpen({ row, type, tree });
};

// 点击物料删除
const handleDelete = (row) => {
  ElMessageBox.confirm(`确定删除药剂【${row.name}】吗?`, "删除", {
    confirmButtonText: "删除",
    cancelButtonText: "取消",
    type: "error",
  })
    .then(() => {
      deleteMedicament(row.id).then((res) => {
        if (res.code == "2000") {
          ElMessage.success("删除成功");
          getList();
        }
      });
    })
    .catch(() => {});
};

const categoryChange = () => {
  getList();
  getTypeTree();
};

onMounted(() => {
  getList();
  getTypeTree();
});
</script>

<template>
  <zh-table-page v-bind="{ title: '药剂管理' }">
    <template #header-btn
      ><el-button
        type="primary"
        icon="Plus"
        @click="handleMaterielAdjust(null, true, typeTree)"
        >新增</el-button
      ></template
    >
    <template #search>
      <el-form :model="searchData" ref="searchRef">
        <el-row :gutter="10">
          <el-col :span="4"
            ><el-form-item prop="name">
              <el-input
                v-model="searchData.name"
                placeholder="药剂名称"
              /> </el-form-item
          ></el-col>
          <el-col :span="4"
            ><el-form-item prop="nickname">
              <el-input
                v-model="searchData.nickname"
                placeholder="药剂简称"
              /> </el-form-item
          ></el-col>
          <el-col :span="4"
            ><el-form-item prop="number">
              <el-input
                v-model="searchData.number"
                placeholder="药剂编号"
              /> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item>
              <el-button type="primary" icon="Search" @click="getList()"
                >查询</el-button
              >
              <el-button icon="Refresh" @click="handleReset()">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #left>
      <div class="tree-title">药剂类别</div>
      <el-tree
        ref="treeRef"
        :data="typeTree"
        node-key="id"
        default-expand-all
        :props="defaultProps"
        :expand-on-click-node="false"
        :highlight-current="true"
        @node-click="handleNodeClick"
        :current-node-key="typeTree[0]?.id"
      >
        <template #default="{ node, data }">
          <span class="custom-tree-node">
            <span>{{ node.label }}</span>
            <span class="btn">
              <el-icon @click.stop="handleCategoryAdjust(node, data, true)"
                ><CirclePlusFilled color="#409EFF"
              /></el-icon>
              <el-icon
                @click.stop="handleCategoryAdjust(node, data, false)"
                v-if="data.parentId != 0"
                ><EditPen color="#67C23A"
              /></el-icon>
              <el-icon
                @click.stop="handleCategoryDelete(data)"
                v-if="data.parentId != 0"
                ><DeleteFilled color="#F56C6C"
              /></el-icon>
            </span>
          </span>
        </template>
      </el-tree>
    </template>
    <template #table>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{
          'text-align': 'center',
        }"
        style="width: 100%"
        max-height="650"
        :data="tableData"
        v-loading="tableLoading"
      >
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            show-overflow-tooltip
            :fixed="item.fixed || false"
            :min-width="120"
          >
            <template #default="{ row }">
              <span v-if="item.prop == 'enable'">{{
                row[item.prop].desc
              }}</span>
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              @click="handleMaterielAdjust(row, false, typeTree)"
              >编辑</el-button
            >
            <el-button type="danger" link @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :total="pageParams.total"
        v-model:current-page="pageParams.page"
        @update:current-page="getList"
        layout="->, prev, pager, next"
        class="mt10"
      />
    </template>
  </zh-table-page>
  <!-- 物料类别编制弹窗 -->
  <category-adjust ref="categoryRef" @after-save="categoryChange" />

  <!-- 物料管理编制弹窗 -->
  <manage-adjust ref="materielRef" @after-save="getList" />
</template>

<style scoped>
.tree-title {
  font-size: 16px;
  height: 20px;
  line-height: 20px;
  padding: 8px 0 10px 8px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.btn {
  width: 60px;
  display: flex;
  justify-content: space-between;
}
</style>
